import { BrowserRouter, Route, Routes } from "react-router";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { RouteTable } from "./lib/routes";
import { ChangePassword } from "./pages/auth/ChangePassword";
import { Login } from "./pages/auth/Login";
import { Register } from "./pages/auth/Register";
import { SetPassword } from "./pages/auth/SetPassword";
import { Dashboard } from "./pages/Dashboard";
import { Layout } from "./pages/Layout";
import { Metabase } from "./pages/Metabase";
import { NotFound } from "./pages/NotFound";
import { Users } from "./pages/users/Users";

export const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Dashboard />} />
          <Route path={RouteTable.metabase.path} element={<Metabase />} />
          <Route path={RouteTable.users.path} element={<Users />} />
          <Route path={RouteTable.changePassword.path} element={<ChangePassword />} />
        </Route>

        <Route path={RouteTable.login.path} element={<Login />} />
        <Route path={RouteTable.register.path} element={<Register />} />
        <Route path={RouteTable.setPassword.path} element={<SetPassword />} />

        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
};
